import { useMemo } from 'react';
import { mapSelection, optimizeSelection } from "./SelectionUtils.js";
/**
 * Given viewport data, maps the current selectedKeys to an optimized selection.
 * The keys are mapped to new values via a `mapItem` function.
 * @param viewportData The viewport to map selections for
 * @param mapItem A function to map an item in the viewport to a new value
 * @param getKey A function to get the key for an item in the viewport.
 */
export function useMappedSelection(viewportData, mapItem, getKey) {
  var getItem = viewportData.getItem,
    selectedKeys = viewportData.selectedKeys,
    items = viewportData.items;
  return useMemo(() => {
    var _optimizeSelection = optimizeSelection(selectedKeys, items.length, getKey),
      selection = _optimizeSelection.selection,
      isInverted = _optimizeSelection.isInverted;
    return {
      selection: mapSelection(selection, getItem, mapItem),
      isInverted
    };
  }, [selectedKeys, items.length, getKey, getItem, mapItem]);
}
export default useMappedSelection;
//# sourceMappingURL=useMappedSelection.js.map